import { render, staticRenderFns } from "./vendor-registration.vue?vue&type=template&id=d2d93694"
import script from "./vendor-registration.vue?vue&type=script&lang=js"
export * from "./vendor-registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports